import { put, takeLatest } from 'redux-saga/effects';

import {
  openUploadDocumentsModal,
  closeUploadDocumentsModal,
} from 'redux/modules/shipper-order-documents/duck';

const openModal$ = 'shipper-order-documents/openModal$';
const closeModal$ = 'shipper-order-documents/closeModal$';

export const openModal = (id) => ({
  type: openModal$,
  payload: {
    shipperOrderId: id,
  },
});

export const closeModal = () => ({
  type: closeModal$,
  payload: {},
});

function* handleOpenModalUploadDocuments({ payload }) {
  const { shipperOrderId } = payload;
  yield put(openUploadDocumentsModal({ shipperOrderId }));
}

function* handleCloseModalUploadDocuments() {
  yield put(closeUploadDocumentsModal());
}

export function* watchShipperOrderDocuments() {
  yield takeLatest(openModal$, handleOpenModalUploadDocuments);
  yield takeLatest(closeModal$, handleCloseModalUploadDocuments);
}
